export { default } from "./ActiveDealsCarousel";
